module.exports = __webpack_public_path__ + "img/about-section-3@2x.b1043c35.jpg";